import { HttpErrorResponse, type HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of, throwError } from 'rxjs';
import { delay } from 'rxjs/operators';

const TEST_UI_ERROR_PREFIX = '/mock-api/test-ui/errors/';
const TIMEOUT_DELAY_MS = 250;

export const testUiMockApiInterceptor: HttpInterceptorFn = (request, next) => {
  const url = new URL(request.url, 'http://localhost');
  const path = url.pathname;

  if (!path.startsWith(TEST_UI_ERROR_PREFIX)) {
    return next(request);
  }

  const scenario = path.slice(TEST_UI_ERROR_PREFIX.length);

  switch (scenario) {
    case 'success':
      return of(
        new HttpResponse({
          status: 200,
          body: {
            ok: true,
            scenario,
            message: 'Mock API success response',
          },
        }),
      );
    case 'network':
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 0,
            statusText: 'Unknown Error',
            error: new ProgressEvent('error'),
            url: request.url,
          }),
      );
    case 'unauthorized':
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 401,
            statusText: 'Unauthorized',
            error: {
              message: 'Session expired',
            },
            url: request.url,
          }),
      );
    case 'forbidden':
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 403,
            statusText: 'Forbidden',
            error: {
              message: 'Insufficient permissions',
            },
            url: request.url,
          }),
      );
    case 'not-found':
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 404,
            statusText: 'Not Found',
            error: {
              message: 'Resource was not found',
            },
            url: request.url,
          }),
      );
    case 'validation':
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 400,
            statusText: 'Bad Request',
            error: {
              status: -4,
              message: 'Validation failed',
              errors: {
                declarationNumber: 'Номер декларации обязателен.',
                amount: 'Сумма должна быть больше нуля.',
                manager: 'Назначьте ответственного менеджера.',
              },
            },
            url: request.url,
          }),
      );
    case 'conflict':
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 409,
            statusText: 'Conflict',
            error: {
              message: 'Version conflict detected',
            },
            url: request.url,
          }),
      );
    case 'server':
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 500,
            statusText: 'Internal Server Error',
            error: {
              message: 'Unexpected server exception',
            },
            url: request.url,
          }),
      );
    case 'backend':
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 422,
            statusText: 'Unprocessable Entity',
            error: {
              code: 'CUSTOM_RULE_FAILED',
              message: 'Кастомное бизнес-правило не позволило выполнить операцию.',
            },
            url: request.url,
          }),
      );
    case 'timeout':
      return of(
        new HttpResponse({
          status: 200,
          body: {
            ok: true,
            scenario,
          },
        }),
      ).pipe(delay(TIMEOUT_DELAY_MS));
    default:
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 404,
            statusText: 'Not Found',
            error: {
              message: `Unknown mock scenario: ${scenario}`,
            },
            url: request.url,
          }),
      );
  }
};
